function textTick(self, countdown, template, defaultText, successCall) {
    function tickCall() {
        if (countdown <= 0) {
            self.html(defaultText);
            successCall && successCall();
        } else {
            self.html(template.replace('{sec}', countdown));
            countdown--;
            setTimeout(tickCall, 1000);
        }
    }

    tickCall();
}

function initNoCaptcha($nc, scene) {

    var asyncNoCaptcha = $.Deferred(function (def) {
        if (!window.noCaptcha) {
            $.ajax({url: '//g.alicdn.com/sd/ncpc/nc.js', dataType: 'script', cache: true}).done(function () {
                def.resolve(window.noCaptcha);
            });
            $('head').append('<link rel="stylesheet" href="//g.alicdn.com/sd/ncpc/nc.css" />');
        } else {
            def.resolve(window.noCaptcha);
        }
    });

    var init = function () {
        var nc_id = 'yc-nc-' + Math.random();
        var nc = new window.noCaptcha();
        var nc_appkey = 'FFFF000000000178DFBD';  // 应用标识,不可更改
        var nc_scene = scene;  //场景,不可更改
        var nc_token = [nc_appkey, (new Date()).getTime(), Math.random()].join(':');
        var ncResult = {};
        var nc_option = {
            renderTo: nc_id,//渲染到该DOM ID指定的Div位置
            appkey: nc_appkey,
            scene: nc_scene,
            token: nc_token,
            // trans: '{"name1":"code0"}',//测试用，特殊nc_appkey时才生效，正式上线时请务必要删除；code0:通过;code100:点击验证码;code200:图形验证码;code300:恶意请求拦截处理
            callback: function (data) {// 校验成功回调
                ncResult['afssession'] = data.csessionid;
                ncResult['afssig'] = data.sig;
                ncResult['afstoken'] = nc_token;
                ncResult['afsscene'] = nc_scene;

                $nc.data('no-captcha', ncResult);
            }
        };

        $nc.empty();
        $nc.data('no-captcha', ncResult);
        $nc.append('<div id="'+nc_id+'"></div>');
        nc.init(nc_option);
    };

    if (!window.noCaptcha) {
        asyncNoCaptcha.done(init);
    } else {
        init();
    }
}
window.initNoCaptcha = initNoCaptcha;

module.exports = {
    textTick: textTick,
    initNoCaptcha: initNoCaptcha
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/@ycgame/auth/src/utils.js
// module id = 3
// module chunks = 1